var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('view-section-card', _vm._b({
    attrs: {
      "title": "도서산간설정 (사용/미사용)",
      "hideDivider": ""
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function () {
        return [_c('v-switch', _vm._b({
          attrs: {
            "value": true
          },
          model: {
            value: _vm.islandsEnabled,
            callback: function ($$v) {
              _vm.islandsEnabled = $$v;
            },
            expression: "islandsEnabled"
          }
        }, 'v-switch', _vm.attrs_switch, false))];
      },
      proxy: true
    }])
  }, 'view-section-card', {
    loading: _vm.loading
  }, false), [_c('v-expand-transition', [_c('v-sheet', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.islandsEnabled,
      expression: "islandsEnabled"
    }]
  }, [_c('v-divider'), _c('v-card-text', _vm._l(_vm.islands, function (island) {
    return _c('v-row', {
      key: island._id
    }, [_c('v-col', {
      attrs: {
        "cols": "12"
      }
    }, [_c('v-text-field', {
      attrs: {
        "label": `'${island.name}' 지역 추가배송비`,
        "persistent-placeholder": "",
        "dense": "",
        "hide-details": ""
      },
      on: {
        "change": _vm.input
      },
      model: {
        value: island.price,
        callback: function ($$v) {
          _vm.$set(island, "price", $$v);
        },
        expression: "island.price"
      }
    })], 1)], 1);
  }), 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }